module.exports = __webpack_public_path__ + "resources/img/equipment_tab2_img3_m.6cb7c8edc44f9ae6fe141480bac4c251.jpg";